import React, { useMemo, useState } from 'react';
import ProductPageTabsMenu from './ProductPageTabsMenu';
import ProductPageTabContent from './ProductPageTabContent';
import { translate } from '../../Services/translation';
import { ProductPageModel } from '../../Types/ProductPageModel';
import ProductPageDescriptionTab from './ProductPageDescriptionTab';
import ProductPageSpecificationsTab from './ProductPageSpecificationsTab';
import ProductPageTrustabilityTab from './ProductPageTrustabilityTab';
import ProductPageFAQTab from './ProductPageFAQTab';
import ProductPageReviewsTab from "./ProductPageReviewsTab";
import {useTypedSelector} from "../../Hooks/useTypedSelector";

const ProductPageTabsContainer = ({
  productPage,
}: {
  productPage: ProductPageModel;
}) => {
  const { showProductReviews } = useTypedSelector(
        (state) => state.featureToggling
  );
  const { reviewInstanceId } = useTypedSelector(
        (state) => state.yotpo
  );
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const items = useMemo(
    () => [
      {
        title: translate('tab-title.product-description'),
        content: <ProductPageDescriptionTab productPage={productPage} />,
        visible:
          productPage.productItem.description &&
          productPage.productItem.description?.length > 0,
      },
      {
        title: translate('tab-title.specifications'),
        content: (
          <ProductPageSpecificationsTab productPage={productPage} />
        ),
        visible:
          productPage.productSpecificationsGroup &&
          productPage.productSpecificationsGroup?.productFields.length > 0,
      },
      {
        title: translate('tab-title.trustability'),
        content: (
          <ProductPageTrustabilityTab
            shippingInfo={productPage.generalShippingInfo}
            returnInfo={productPage.generalReturnInfo}
          />
        ),
        visible:
          productPage.generalShippingInfo || productPage.generalReturnInfo,
      },
      {
        title: translate('tab-title.faq'),
        content: (
          <ProductPageFAQTab
            show={productPage.faqItems.length > 0}
            items={productPage.faqItems}
          />
        ),
      },
    ],
    [productPage]
  );
  
  if(showProductReviews && !!reviewInstanceId) {
      items.push(
          {
              title: translate('tab-title.reviews'),
              content: (
                  <ProductPageReviewsTab
                      product={productPage.productItem}
                  />
              )
          }
      )
  }

  const filteredItemList = useMemo(
    () => items.filter((item) => !!item.content && item.visible !== false),
    [items]
  );

  return (
    <div className="lg:container mb-6 border-t border-gray-100 lg:mb-16 lg:border-t-0">
      <ProductPageTabsMenu
        tabs={filteredItemList}
        setActiveTab={setActiveTabIndex}
        activeTabIndex={activeTabIndex}
      />
      {filteredItemList.map((item, idx) => (
        <ProductPageTabContent
          key={item.title + idx}
          item={item}
          active={activeTabIndex == idx}
        />
      ))}
    </div>
  );
};

export default ProductPageTabsContainer;
